// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__q5-zp","detailsBtn":"ErrorBoundary_detailsBtn__iTaIc","errorDiv":"ErrorBoundary_errorDiv__CKpY3"};